<template>
  <div>
    <scopes-technical-table
      :activity="activity"
      v-if="activity"
      :title="
        ['OCPR', 'OCPE', 'OINSP', 'OVV'].includes(this.activity)
          ? 'ALCANCE DE LA ACREDITACIÓN SOLICITADA'
          : ['CSGAS', 'OCSG', 'CSA', 'CSIA', 'OEAP', 'CSST', 'CSEN'].includes(this.activity)
          ? 'ALCANCE DE ACREDITACIÓN'
          : ['OENY', 'OEYC', 'CSDM'].includes(this.activity)
          ? 'ALCANCE DE LA ACREDITACIÓN'
          : ['OCLN', 'OICC'].includes(this.activity)
          ? 'ALCANCE DE LA ACREDITACIÓN'
          : ''
      "
    />

    <div v-if="['OENY', 'OICC'].includes(this.activity)">
      <scope-sampling-table
        title="¿Incluye muestreo?"
        tableId="scope-sampling-table"
        modalTitle="Añadir Muestra"
        editModalTitle="Editar Muestra"
        :activity="activity"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      delayTimer: null,
    };
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
  },
  watch: {
    "inputs.normative_documents": function () {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(this.update, 1000);
    },
    "inputs.evaluation_date": function () {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(this.update, 1000);
    },
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const { data } = res.data;
      this.inputs = {
        id: data.id,
        scope_check_1: data.scope_check_1,
        scope_check_2: data.scope_check_2,
        scope_text_1: data.scope_text_1,
        scope_text_2: data.scope_text_2,
        normative_documents: data.normative_documents,
        evaluation_date: data.evaluation_date
          ? new Date(data.evaluation_date)
          : null,
      };
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;
      this.axiosGet(
        `/accreditations/applications/form/${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.inputs = {
              id: response.data.id,
              scope_check_1: response.data.scope_check_1,
              scope_check_2: response.data.scope_check_2,
              scope_text_1: response.data.scope_text_1,
              scope_text_2: response.data.scope_text_2,
              normative_documents: response.data.normative_documents,
              evaluation_date: response.data.evaluation_date
                ? new Date(response.data.evaluation_date)
                : null,
            };
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    update() {
      const tmp = {
        id: this.inputs.id,
        normative_documents: this.inputs.normative_documents,
        evaluation_date: this.inputs.evaluation_date,
      };

      if (tmp.evaluation_date) {
        const d = tmp.evaluation_date;
        tmp.evaluation_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }

      axiosPost("/request/accApp/", tmp)
        .then((res) => {})
        .catch(({ error }) => {});
    },
  },
};
</script>
